import Vue from 'vue';

import defaults from 'lodash/defaults';
import result from 'lodash/result';

import Confirmer from './dialogs/confirmer.vue';
import Alert from './dialogs/alert.vue';

import router from '../router';

class ComponentCreator {
   dialog(Component, options = {}) {
      const el = document.createElement('div');
      document.body.appendChild(el);

      options = defaults({ el, router }, options);

      return new Promise((resolve, reject) => {
         options = Vue.util.extend(options, Component);
         delete options.name;
         const dialog = new Vue(options);

         dialog.$on('close', _close);
         dialog.$on('confirm', _confirm);

         function _close() {
            
            const value = result(dialog, 'rejectedValue', null);
            _removeDialog();
            if (value) {
               resolve(value);
            } else {
               reject();
            }
         }

         function _confirm() {
            _removeDialog();
            resolve(result(dialog, 'resolvedValue', null));
         }

         function _removeDialog() {
            dialog.$destroy(true);
            document.body.removeChild(dialog.$el, true);
         }
      });
   }

   async confirm(message) {
      try {
         await this.dialog(Confirmer, { message });
         return true;
      } catch(e) {
         return false;
      }
   }

   async alert(message) {
      try {
         await this.dialog(Alert, { message });
         return true;
      } catch(e) {
         return false;
      }
   }
}

export default new ComponentCreator();
